(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('LoginController', LoginController);

    LoginController.$inject = ['$rootScope', '$state', '$sessionStorage', '$timeout', 'Auth', 'Principal'];

    function LoginController($rootScope, $state, $sessionStorage, $timeout, Auth, Principal) {
        var vm = this;

        vm.authenticationError = false;
        vm.cancel = cancel;
        vm.credentials = {};
        vm.login = login;
        vm.password = null;
        vm.rememberMe = true;
        vm.username = null;
        vm.view = 'login';

        vm.error = null;
        vm.errorEmailNotExists = null;
        vm.requestReset = requestReset;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function () {
            angular.element('#email').focus();
        });

        function requestReset() {

            vm.error = null;
            vm.errorEmailNotExists = null;

            Auth.resetPasswordInit(vm.resetAccount.email).then(function () {
                vm.success = 'OK';
                vm.resetAccount.email = "";
            }).catch(function (response) {
                vm.success = null;
                if (response.status === 400 && response.data === 'e-mail address not registered') {
                    vm.errorEmailNotExists = 'ERROR';
                } else {
                    vm.error = 'ERROR';
                }
            });
        }

        $timeout(function () {
            angular.element('#username').focus();
        });

        function cancel() {
            vm.credentials = {
                username: null,
                password: null,
                rememberMe: true
            };
            vm.authenticationError = false;
            $uibModalInstance.dismiss('cancel');
        }

        function login(event) {
            event.preventDefault();
            Auth.login({
                username: vm.username,
                password: vm.password,
                rememberMe: vm.rememberMe
            }).then(function () {
                vm.authenticationError = false;
                // $uibModalInstance.close();

                // Principal.identity(true).then(function (account) {
                //     if (account.authorities.length == 1)
                //         $state.go('tab-objects-dashboard');
                //     else
                //         $state.go('home'); //cambio stato solo dopo che la promise è stata risolta per evitare N chiamate parallele per la risoluzione degli state dell'app
                // });

                Principal.identity(true).then(function (account) {
                    $state.go('tab-objects-dashboard');
                });

                // if ($state.current.name === 'register' || $state.current.name === 'activate' ||
                //     $state.current.name === 'finishReset' || $state.current.name === 'requestReset') {
                // }

                $rootScope.$broadcast('authenticationSuccess');

                // previousState was set in the authExpiredInterceptor before being redirected to login modal.
                // since login is succesful, go to stored previousState and clear previousState
                // if ($sessionStorage.previousStateName) {
                //     var previousStateName = $sessionStorage.previousStateName;
                //     var previousStateParams = $sessionStorage.previousStateParams;
                //     delete $sessionStorage.previousStateName;
                //     delete $sessionStorage.previousStateParams;
                //     $state.go(previousStateName, previousStateParams);
                // }
            }).catch(function () {
                vm.authenticationError = true;
            });
        }
    }
})();
